module.exports = __webpack_public_path__ + "img/check-green.eb67044e.svg";